import { ETL_INTEGRATION_TYPE, Values } from '../components/configuration/types';

/**
 * GENERAL
 */
export const PATH_MAIN_ROUTE = '/';
export const PATH_ACCESS_FORBIDDEN = '/access-forbidden';

/**
 * SCENES
 */
export const PATH_MY_CONFIGURATIONS = 'my-configurations';
export const PATH_NEW_CONFIGURATION = 'new';
export const PATH_EDIT_CONFIGURATION = 'edit';

export const createMyConfigurationsUrl = () => {
  return `${PATH_MAIN_ROUTE}${PATH_MY_CONFIGURATIONS}`;
};

export const createEditConfigurationUrl = (integration: Values<typeof ETL_INTEGRATION_TYPE>, id: number) => {
  return `${PATH_MAIN_ROUTE}${PATH_MY_CONFIGURATIONS}/${PATH_EDIT_CONFIGURATION}/${integration}/${id}`;
};

export const createPickNewConfigurationUrl = () => {
  return `${PATH_MAIN_ROUTE}${PATH_MY_CONFIGURATIONS}/${PATH_NEW_CONFIGURATION}`;
};

export const createNewConfigurationUrl = (integration: Values<typeof ETL_INTEGRATION_TYPE>) => {
  return `${PATH_MAIN_ROUTE}${PATH_MY_CONFIGURATIONS}/${PATH_NEW_CONFIGURATION}/${integration}`;
};
